import { api } from "@/lib/api";

import type {
  CreateReceivablePaymentReq,
  Receivable,
  ReceivableList,
  ReceivableStatus,
  UpdateReceivablePaymentReq,
  UpsertReceivableMetaReq,
} from "@artisancode/api-types";

export interface ReceivableListParams {
  page?: number;
  per_page?: number;
  q?: string;
  status?: ReceivableStatus;
  date_from?: string;
  date_to?: string;
  workspace_id?: string;
}

export const receivableService = {
  list: (params?: ReceivableListParams) =>
    api.get<ReceivableList>(
      "/receivables",
      params as Record<string, string | number | boolean | undefined>,
    ),

  recordPayment: (
    saleId: string,
    body: CreateReceivablePaymentReq,
    idempotencyKey?: string,
  ) =>
    api.post<Receivable>(
      `/receivables/${saleId}/payments`,
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  updatePayment: (paymentId: string, body: UpdateReceivablePaymentReq) =>
    api.patch<Receivable>(`/receivables/payments/${paymentId}`, body),

  deletePayment: (paymentId: string) =>
    api.del<Receivable>(`/receivables/payments/${paymentId}`),

  upsertMeta: (saleId: string, body: UpsertReceivableMetaReq) =>
    api.patch<Receivable>(`/receivables/${saleId}`, body),
};
